<template>
  <t-form ref="form" class="contact-pro-form" @submit.prevent>
    <t-text-field
      v-model="companyName"
      class="contact-pro-form__company"
      :label="$t('field.company-name.label')"
      autocomplete="organization"
      :error-messages="companyNameErrors"
      type="text"
      @blur="validateCompanyName"
    />

    <t-text-field
      v-model="phone"
      class="contact-pro-form__phone"
      :label="$t('field.phone.label')"
      inputmode="tel"
      autocomplete="tel"
      :error-messages="phoneErrors"
      @blur="validatePhone"
    />

    <t-text-field
      v-model="contactName"
      class="contact-pro-form__contact"
      :label="$t('field.contact-name.label')"
      autocomplete="name"
      :error-messages="contactNameErrors"
      type="text"
      @blur="validateContactName"
    />

    <t-text-field
      v-model="email"
      class="contact-pro-form__email"
      :label="$t('field.email.label')"
      type="email"
      inputmode="email"
      autocomplete="email"
      :error-messages="emailErrors"
      @blur="validateEmail"
    />

    <p class="contact-pro-form__submit-btn-title">
      {{ $t('contact-pro.request-meeting') }}
    </p>

    <t-btn
      id="submitContactProForm"
      class="contact-pro-form__submit-btn"
      color="primary"
      :disabled="submitBtnIsDisabled"
      @click="onSubmit"
    >
      {{ $t('global.contact-us') }}
    </t-btn>
  </t-form>
</template>

<script>
import ContactProForm from 'chimera/all/components/form/contact/ContactProForm'

export default {
  name: 'ContactForm',

  extends: ContactProForm,
}
</script>

<i18n>
{
  "nl-NL": {
    "contact-pro.request-meeting": "Vraag een kennismakingsgesprek aan"
  },
  "en-GB": {
    "contact-pro.request-meeting": "Request a free information meeting!"
  }
}
</i18n>
